import UserInfo from './user_info/index'
import DialogTemplate from './dialog_template/index'
import BaseInput from './base_input/index'

interface VueInterface {
    component: (componentName: string, component: object) => object
}

const components: {
    [propName: string]: {
        install: (Vue: VueInterface) => any
    }
} = {
    UserInfo,
    DialogTemplate,
    BaseInput
}

export default {
    install(Vue: VueInterface) {
        for (const i in components) {
            components[i].install(Vue)
        }
    }
}
